module.exports = __webpack_public_path__ + "img/icon_sign.7f7212b5.svg";